import axios from "axios";
import { FETCH_MAINTENANCE_SHEDULES_FAILURE, FETCH_MAINTENANCE_SHEDULES_REQUEST, FETCH_MAINTENANCE_SHEDULES_SUCCESS, FETCH_MAINTENANCE_SHEDULES_SUCCESS_2, FETCH_MAINTENANCE_SHEDULE_FAILURE, FETCH_MAINTENANCE_SHEDULE_REQUEST, FETCH_MAINTENANCE_SHEDULE_SUCCESS,  } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";



// Create MainteanceShedule
export const MainteanceSheduleCreate = (
    data,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_MAINTENANCE_SHEDULE_REQUEST });
        await axios
            .post(
                `${baseurl.url}/api/v1/mainteanceshedules/`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success("nouvel type de véhicule ajouté");
                dispatch({ type: FETCH_MAINTENANCE_SHEDULE_SUCCESS });
            })
            .catch((error) => {
                toast.error("type de véhicule non ajouté")
                dispatch({ type: FETCH_MAINTENANCE_SHEDULE_FAILURE, payload: error.message });
            });
    };
}



// update insurance 
export const MainteanceSheduleUpdateById = (idMainteanceShedule, data, toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_MAINTENANCE_SHEDULE_REQUEST });
        await axios
            .put(`${baseurl.url}/api/v1/mainteanceshedules/update/${idMainteanceShedule}`, data, {
                headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            })
            .then((response) => {
                dispatch({ type: FETCH_MAINTENANCE_SHEDULE_SUCCESS });
                dispatch(fetchMainteanceSheduleById(idMainteanceShedule));
                toast.success("Type de véhicle mis à jour");
            })
            .catch((error) => {
                dispatch({ type: FETCH_MAINTENANCE_SHEDULE_FAILURE, payload: error.message });
                toast.error("Véhicule non mis à jour")
            });
    };
}





// All insurance of plateforme
export function fetchMainteanceShedulesAll() {
    return async (dispatch) => {
        dispatch({ type: FETCH_MAINTENANCE_SHEDULES_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/mainteanceshedules/get_mainteanceshedules`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_MAINTENANCE_SHEDULES_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_MAINTENANCE_SHEDULES_SUCCESS_2, payload: response.data.data });
            saveDataToFile(response.data.data, localStorageData.MainteanceShedules);
        })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_MAINTENANCE_SHEDULES_FAILURE, payload: error.message });
            });
    }
}


// get insurance by id 
export function fetchMainteanceSheduleById(idMainteanceShedule) {
    return async (dispatch) => {
        dispatch({ type: FETCH_MAINTENANCE_SHEDULE_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/mainteanceshedules/get_vehicle_type/${idMainteanceShedule}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_MAINTENANCE_SHEDULE_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_MAINTENANCE_SHEDULE_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}

